import React from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';

// Bloque del formulario de cotización: misma tarjeta, padding y encabezado en todas las
// secciones, para que todas compartan bordes y se lean como un solo formulario.
const FormSection = function (props) {
  const { title, description, action, children } = props;
  return (
    <Card sx={{ height: '100%' }}>
      <CardContent sx={{ p: 3, '&:last-child': { pb: 3 } }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            gap: 2,
            mb: 2.5,
          }}>
          <Box>
            <Typography variant="h6" component="h2" sx={{ fontWeight: 500, lineHeight: 1.3 }}>
              {title}
            </Typography>
            {description && (
              <Typography variant="body2" color="text.secondary" mt={0.5}>
                {description}
              </Typography>
            )}
          </Box>
          {action}
        </Box>
        {children}
      </CardContent>
    </Card>
  );
};

export default FormSection;
